export interface AuditLogEntry {
  email: string;
  activity: string;
  event: string;
  timestamp: string;
}

export const auditLogs: AuditLogEntry[] = [
  {
    email: "himangshu.dey@gmail.com",
    activity: "update",
    event: "Add role",
    timestamp: "18-05-2025, 10:21 am",
  },
  {
    email: "himangshu.dey@gmail.com",
    activity: "View",
    event: "Status",
    timestamp: "17-05-2025, 18:41 pm",
  },
  {
    email: "himangshu.dey@gmail.com",
    activity: "Upload",
    event: "Mark Sheet",
    timestamp: "17-05-2025, 10:21 am",
  },
  {
    email: "himangshu.dey@gmail.com",
    activity: "Download",
    event: "Document",
    timestamp: "29-04-2025, 9:20 am",
  },
];
